/* unplugin-vue-components disabled */import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/es.object.to-string.js";
import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "picker-columns-top",
  flex: "box:justify"
};
var _hoisted_2 = ["flex"];
var _hoisted_3 = ["flex"];
var _hoisted_4 = ["flex"];
import dayjs from 'dayjs';
import Popup from './Popup.vue';
import { showToast } from 'vant';
import useDatePicker from './hook';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import { DAYJS_FORMAT, CHAR } from '@/config/common';
export default /*#__PURE__*/_defineComponent({
  __name: 'PikerWeek',
  props: /*#__PURE__*/_mergeModels({
    data: {}
  }, {
    "modelValue": {},
    "modelModifiers": {}
  }),
  emits: /*#__PURE__*/_mergeModels(["confirm-week"], ["update:modelValue"]),
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    dayjs.extend(weekOfYear);
    var props = __props;
    var _toRefs = toRefs(props),
      data = _toRefs.data;
    var emit = __emit;
    var _useDatePicker = useDatePicker(),
      spacer = _useDatePicker.spacer,
      minYear = _useDatePicker.minYear,
      zeroFill = _useDatePicker.zeroFill,
      isCurrentUnit = _useDatePicker.isCurrentUnit,
      rangeErrorPrev = _useDatePicker.rangeErrorPrev,
      rangeErrorNext = _useDatePicker.rangeErrorNext,
      visibleOptionNum = _useDatePicker.visibleOptionNum;
    var yearNumeric = ref(0);
    var model = _useModel(__props, "modelValue");
    var weekList = ref([]);
    var center = ref('main:center cross:center');
    var currentValue = ref([1]);
    var columns = computed(function () {
      var cloneWeeks = _.reverse(_.cloneDeep(weekList.value));
      var list = _.map(cloneWeeks, function (item, index) {
        item.value = _.add(index, 1);
        item.text = generateText(item);
        return item;
      });
      return _.reverse(list);
    });
    var yearIns = computed(function () {
      return dayjs("".concat(yearNumeric.value)).format(DAYJS_FORMAT.YYYY_CN);
    });
    watch(model, function (newVal) {
      if (newVal) {
        yearNumeric.value = data.value.startTime.year();
        generateWeeks();
      } else {
        setTimeout(currentValueSync);
      }
    });
    watch(data, dataChange, {
      deep: true
    });
    function dataChange() {
      yearNumeric.value = data.value.startTime.year();
      generateWeeks();
      currentValueSync();
    }
    function stepYear(step) {
      if (_.eq(step, 'prev')) {
        var presetYear = _.subtract(yearNumeric.value, 1);
        if (_.gt(minYear.value, presetYear)) {
          showToast(rangeErrorPrev.value);
        } else {
          yearNumeric.value = presetYear;
          generateWeeks();
        }
      } else if (_.eq(step, 'next')) {
        var _presetYear = _.add(yearNumeric.value, 1);
        if (_.gt(_presetYear, dayjs().year())) {
          showToast(rangeErrorNext.value);
        } else {
          yearNumeric.value = _presetYear;
          generateWeeks();
        }
      } else {
        showToast('步进器类型错误');
      }
    }
    function onCancel() {
      model.value = false;
    }
    function onConfirm(option) {
      model.value = false;
      emit('confirm-week', option);
    }
    function currentValueSync() {
      var _item$value;
      var timestamp = data.value.startTime.valueOf();
      var item = _.find(columns.value, function (item) {
        return _.eq(item.startTime.valueOf(), timestamp);
      });
      currentValue.value = item ? [(_item$value = item.value) !== null && _item$value !== void 0 ? _item$value : 1] : [1];
    }
    function generateWeeks() {
      var todayOfYear = dayjs();
      var firstDayOfYear = dayjs("".concat(yearNumeric.value));
      if (isCurrentUnit(firstDayOfYear, 'year')) {
        todayOfYear = dayjs();
      } else {
        todayOfYear = firstDayOfYear.endOf('year');
      }
      weekList.value = _.stubArray();
      for (var date = firstDayOfYear; date.isSameOrBefore(todayOfYear); date = date.add(1, 'day')) {
        if (date.day() === 1) {
          var weekEnd = null;
          var weekStart = date;
          var numeric = date.week();
          var endDate = date.add(6, 'day').endOf('day');
          if (endDate.isAfter(dayjs())) {
            weekEnd = dayjs();
          } else {
            if (isCurrentUnit(endDate, 'year')) {
              weekEnd = endDate;
            } else {
              weekEnd = weekStart.endOf('year');
            }
          }
          var year = weekStart.year();
          weekList.value.push({
            year: year,
            numeric: numeric,
            endTime: weekEnd,
            startTime: weekStart
          });
        }
      }
    }
    function generateText(item) {
      var start = item.startTime.format(DAYJS_FORMAT.MMDD_SLASH);
      var end = item.endTime.format(DAYJS_FORMAT.MMDD_SLASH);
      var weekText = "\u7B2C".concat(zeroFill(item.numeric), "\u5468");
      var yearText = "".concat(item.year, "\u5E74");
      var snippets = [yearText, spacer(weekText), start, spacer(CHAR.TILDE), end];
      return _.join(snippets, CHAR.NUL);
    }
    return function (_ctx, _cache) {
      var _component_van_icon = _resolveComponent("van-icon");
      var _component_van_picker = _resolveComponent("van-picker");
      return _openBlock(), _createBlock(Popup, {
        modelValue: model.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = function ($event) {
          return model.value = $event;
        })
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_van_picker, {
            columns: _unref(columns),
            onCancel: onCancel,
            onConfirm: onConfirm,
            modelValue: _unref(currentValue),
            "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
              return _isRef(currentValue) ? currentValue.value = $event : null;
            }),
            "visible-option-num": _unref(visibleOptionNum)
          }, {
            "columns-top": _withCtx(function () {
              return [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
                class: "step step-left",
                flex: _unref(center),
                onClick: _cache[0] || (_cache[0] = function ($event) {
                  return stepYear('prev');
                })
              }, [_createVNode(_component_van_icon, {
                name: "arrow-left",
                size: "16"
              })], 8, _hoisted_2), _createElementVNode("div", {
                class: "picker-columns-top_title",
                flex: _unref(center)
              }, [_createElementVNode("span", null, _toDisplayString(_unref(yearIns)), 1)], 8, _hoisted_3), _createElementVNode("div", {
                class: "step step-right",
                flex: _unref(center),
                onClick: _cache[1] || (_cache[1] = function ($event) {
                  return stepYear('next');
                })
              }, [_createVNode(_component_van_icon, {
                name: "arrow",
                size: "16"
              })], 8, _hoisted_4)])];
            }),
            _: 1
          }, 8, ["columns", "modelValue", "visible-option-num"])];
        }),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});